import Swiper from "./swiper-bundle.esm.browser.min.js";

console.log("[tile-media-swipe] module loaded v2");

if (!customElements.get("tile-media-swipe")) {
  customElements.define(
    "tile-media-swipe",
    class TileMediaSwipe extends HTMLElement {
      connectedCallback() {
        console.log("[tile-media-swipe] connectedCallback", this);

        const container = this.querySelector("[data-mobile-swipe-swiper]");
        const slideCount = container ? container.querySelectorAll(".swiper-slide").length : 0;
        console.log("[tile-media-swipe] container found:", !!container, "slideCount:", slideCount);

        if (!container || slideCount < 2) {
          console.warn("[tile-media-swipe] bailing out — no container or <2 slides");
          return;
        }

        try {
          this.swiper = new Swiper(container, {
            slidesPerView: 1,
            speed: 300,
            threshold: 5,
            nested: true,
            pagination: {
              el: container.querySelector(".swiper-pagination"),
              clickable: true,
            },
            on: {
              afterInit: (swiper) => {
                console.log("[tile-media-swipe] afterInit OK, slides:", swiper.slides.length);
                this.handleSlideChange(swiper);
              },
              slideChange: (swiper) => {
                console.log("[tile-media-swipe] slideChange -> index", swiper.activeIndex);
                this.handleSlideChange(swiper);
              },
              touchStart: () => console.log("[tile-media-swipe] touchStart"),
              touchMove: () => console.log("[tile-media-swipe] touchMove"),
              touchEnd: () => console.log("[tile-media-swipe] touchEnd"),
            },
          });
          console.log("[tile-media-swipe] swiper initialized OK", this.swiper);
        } catch (err) {
          console.error("[tile-media-swipe] Swiper init threw:", err);
          return;
        }

        this.observePageVisibility();
      }

      disconnectedCallback() {
        this.pageObserver?.disconnect();
        this.swiper?.destroy();
      }

      pauseAllVideos(swiper) {
        swiper.slides.forEach((slide) => slide.querySelector("video")?.pause());
      }

      handleSlideChange(swiper) {
        this.pauseAllVideos(swiper);
        swiper.slides[swiper.activeIndex]
          ?.querySelector("video")
          ?.play()
          .catch((err) => console.warn("[tile-media-swipe] video.play() rejected:", err));
      }

      observePageVisibility() {
        this.pageObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting && this.swiper) this.pauseAllVideos(this.swiper);
            });
          },
          { root: null, threshold: 0 },
        );
        this.pageObserver.observe(this);
      }
    },
  );
}
